import React, { useContext } from "react";

import "./EMRReadings.css";
import {
  ApplicationContext,
  ProviderContext,
} from "../../ApplicationState";
import MeasurementDisplay, { Measurement } from "../../components/EMRReadingsComponent";
import { IonBackButton, IonButtons, IonCard, IonCardContent, IonCardHeader, IonContent, IonHeader, IonPage, IonTitle, IonToolbar } from "@ionic/react";
import Header from "../../components/Header/Header";
import { arrowBackCircleSharp } from "ionicons/icons";
import { postEMRMeasurement, postEMRMeasurements } from "../../services/ApiService";
import { Box } from "@mui/material";

var _ = require("lodash");

const EMRReadings: React.FC<any> = (props: any) => {
  const { userState } = useContext(ApplicationContext);
  const { providerState } = useContext(ProviderContext);


  const handleSingleSubmit = async (measurement: Measurement) => {
    try {
      // Use your existing postEMRMeasurement service
      const result = await postEMRMeasurement(userState.authenticatedUser, measurement);
      console.log('Submission successful:', result);

      // You might want to show a success message here
      // toast.success('Reading submitted successfully!');

      return result;
    } catch (error) {
      console.error('Error submitting reading:', error);
      // You might want to show an error message here
      // toast.error('Failed to submit reading');
      throw error;
    }
  };

  const handleBulkSubmit = async (measurements: Measurement[]) => {
    try {
      if (measurements.length === 0) {
        throw new Error('No measurements selected');
      }

      // Use your existing postEMRMeasurements service
      const result = await postEMRMeasurements(userState.authenticatedUser, measurements);
      console.log('Bulk submission successful:', result);

      // You might want to show a success message here
      // toast.success(`${measurements.length} readings submitted successfully!`);

      return result;
    } catch (error) {
      console.error('Error submitting multiple readings:', error);
      // You might want to show an error message here
      // toast.error('Failed to submit readings');
      throw error;
    }
  };

  return (
    <>
      {/* <Header /> */}
      {/* <IonHeader>
        <IonToolbar color="light">
          <IonButtons slot="start">
            <IonBackButton
              text="Go Back"
              icon={arrowBackCircleSharp}
              defaultHref="/"
            />
          </IonButtons>
          <IonTitle>Observations</IonTitle>

        </IonToolbar>
      </IonHeader> */}
      {/* <IonContent className="ion-padding">
        <IonCard>

          <IonCardContent> */}
      <div style={{
        // marginTop: 30,
        overflowY: "scroll"
      }}>
        <MeasurementDisplay
          loggedInUser={userState.authenticatedUser}
          groupcode={providerState.providerId}
          onSubmitReading={handleSingleSubmit}
          onSubmitMultipleReadings={handleBulkSubmit}
          refreshInterval={60000} // Optional: auto-refresh every 60 seconds
        />
      </div>
      {/* </IonCardContent>
        </IonCard>
      </IonContent> */}
    </>

  );
};
export default EMRReadings;
